import React, { useState, useEffect } from "react";

export default function ColorMixGame() {
    const [target, setTarget] = useState({ r: 0, g: 0, b: 0 });
    const [guess, setGuess] = useState({ r: 128, g: 128, b: 128 });
    const [score, setScore] = useState(null);
    const [round, setRound] = useState(1);

    useEffect(() => {
        generateNewColor();
    }, []);

    function generateNewColor() {
        setTarget({
            r: Math.floor(Math.random() * 256),
            g: Math.floor(Math.random() * 256),
            b: Math.floor(Math.random() * 256)
        });
        setGuess({ r: 128, g: 128, b: 128 });
        setScore(null);
    }

    function handleSliderChange(channel, value) {
        setGuess(prev => ({ ...prev, [channel]: Number(value) }));
    }

    function evaluate() {
        const dr = target.r - guess.r;
        const dg = target.g - guess.g;
        const db = target.b - guess.b;

        const distance = Math.sqrt(dr*dr + dg*dg + db*db); // color difference 0–~441

        // Convert to score 0–100
        const scoreValue = Math.max(0, Math.round(100 - (distance / 441) * 100));
        setScore(scoreValue);
    }

    return (
        <div style={{ textAlign: "center", marginTop: "30px" }}>
            <h2>🎨 Color Mixing Challenge</h2>
            <p>Round {round}</p>

            {/* TARGET & GUESS COLORS */}
            <div style={{
                display: "flex",
                justifyContent: "center",
                gap: "40px",
                marginBottom: "20px",
            }}>
                {/* Target Color */}
                <div>
                    <h3>Target Color</h3>
                    <div style={{
                        width: "150px",
                        height: "150px",
                        backgroundColor: `rgb(${target.r}, ${target.g}, ${target.b})`,
                        border: "3px solid black",
                        borderRadius: "8px"
                    }} />
                </div>

                {/* Guess Color */}
                <div>
                    <h3>Your Color</h3>
                    <div style={{
                        width: "150px",
                        height: "150px",
                        backgroundColor: `rgb(${guess.r}, ${guess.g}, ${guess.b})`,
                        border: "3px solid black",
                        borderRadius: "8px"
                    }} />
                </div>
            </div>

            {/* SLIDERS */}
            <div style={{ maxWidth: "500px", margin: "0 auto" }}>
                {["r", "g", "b"].map(channel => (
                    <div key={channel} style={{ margin: "10px 0" }}>
                        <label>
                            {channel.toUpperCase()}: {guess[channel]}
                        </label>
                        <input
                            type="range"
                            min="0"
                            max="255"
                            value={guess[channel]}
                            onChange={(e) => handleSliderChange(channel, e.target.value)}
                            style={{ width: "100%" }}
                        />
                    </div>
                ))}
            </div>

            {/* BUTTONS */}
            <div style={{ marginTop: "20px" }}>
                <button
                    onClick={evaluate}
                    style={{
                        padding: "10px 20px",
                        marginRight: "10px",
                        backgroundColor: "#d63384",
                        color: "white",
                        border: "none",
                        borderRadius: "6px",
                        cursor: "pointer"
                    }}
                >
                    Check Match
                </button>

                <button
                    onClick={() => {
                        generateNewColor();
                        setRound(r => r + 1);
                    }}
                    style={{
                        padding: "10px 20px",
                        backgroundColor: "#6f42c1",
                        color: "white",
                        border: "none",
                        borderRadius: "6px",
                        cursor: "pointer"
                    }}
                >
                    New Color
                </button>
            </div>

            {/* SCORE */}
            {score !== null && (
                <h2 style={{ marginTop: "20px" }}>
                    Match Score: <span style={{ color: "#d63384" }}>{score}</span> / 100
                </h2>
            )}
        </div>
    );
}
